import { forwardRef } from 'react';
import { Slide } from '@mui/material';

export const DialogTransition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
